import { Container, Grid, GridSize } from '@material-ui/core';
import React from 'react';
import BreadCrumb from '../BreadCrumb/BreadCrumb';
import { IBreadCrumbItem } from '../BreadCrumb/BreadCrumbItem';
import PageSubtitle from '../PageSubtitle/PageSubtitle';
import PageTitle from '../PageTitle/PageTitle';
import { isMobileMediaQuery } from './../Layout/Layout';
import styles from './PrivateContainer.scss';
const rootClassName = styles.rootClassName;


export interface IPrivateContainer {
  title?: string,
  titleMaxLength?: number,
  breadCrumb?: IBreadCrumbItem[],
  subtitle?: string,
  rightContent?: React.ReactNode,
  leftContentGridProps?: { xs?: GridSize, sm?: GridSize, md?: GridSize, lg?: GridSize, xl?: GridSize, className?: string },
  rightContentGridProps?: { xs?: GridSize, sm?: GridSize, md?: GridSize, lg?: GridSize, xl?: GridSize, className?: string },
  noPadding?: boolean;
  noScroll?: boolean;
}

export interface IPrivateContainerState {
  isMobile: boolean
}

class PrivateContainer extends React.Component<IPrivateContainer, IPrivateContainerState> {

  constructor(props: IPrivateContainer) {
    super(props);
    this.state = {
      isMobile: window.matchMedia(isMobileMediaQuery).matches,
    };
  }

  onMediaQuery = (event: MediaQueryListEvent) => {
    this.setState({
      isMobile: event.matches
    });
  }

  UNSAFE_componentDidMount() {
    window.matchMedia(isMobileMediaQuery).addListener(this.onMediaQuery);
  }

  UNSAFE_componentWillUnmount() {
    window.matchMedia(isMobileMediaQuery).removeListener(this.onMediaQuery);
  }

  getTitle = () => {
    if (!this.props.title) {
      return null;
    }
    return <PageTitle title={ this.props.title } titleMaxLength={ typeof this.props.titleMaxLength === 'number' ? this.props.titleMaxLength : null} />
  }

  getBreadCrumb = () => {
    if (!this.props.breadCrumb) {
      return null;
    }
    return <BreadCrumb itens={ this.props.breadCrumb } />
  }

  getSubtitle = () => {
    if (!this.props.subtitle) {
      return null;
    }
    return <PageSubtitle subtitle={ this.props.subtitle } />
  }

  render() {
    const { isMobile } = this.state;
    const rootClass: string = isMobile ? rootClassName + '-is-mobile' : rootClassName + '-is-desktop'
    const noPadding = this.props.noPadding ? `${rootClassName}-no-padding` : undefined;
    const noScroll = this.props.noScroll ? `${rootClassName}-no-scroll` : undefined;
    return (
      <Container className={[rootClass, noPadding, noScroll].join(' ').trim()}>
        <Grid container spacing={ 0 }>
          <Grid item { ...(this.props.leftContentGridProps || { xs: 12 }) }>
            {
              this.getTitle()
            }
            {
              this.getBreadCrumb()
            }
            {
              this.getSubtitle()
            }
          </Grid>
          {
            this.props.rightContent ? (
              <Grid item { ...(this.props.rightContentGridProps || { xs: 12 }) }>
                { this.props.rightContent }
              </Grid>
            ) : null
          }
        </Grid>
        {
          this.props.children
        }
      </Container>
    )
  }
}

export default PrivateContainer;